import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { useAuth, useLinks } from "hooks";
import Overlay from "components/Overlay";
import { UserFullName } from "components/User";
import { PrimaryButton } from "components/Buttons";
import { ProfileCard, ProfileModal } from "components/Profile";

/**
 * ProfileLink
 *
 * @param {Object}  profile
 * @param {Boolean} withOverlay
 * @param {Boolean} openModalOnClick
 */
const ProfileLink = ({ profile, withOverlay, openModalOnClick, ...props }) => {
  const { isAdmin } = useAuth();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const links = useLinks();

  const handleShowProfile = () => {
    if (!isAdmin) {
      window.open(links.public_profile(profile?.uuid), "_blank");
      return;
    }

    setShowProfileModal(true);
  };
  const handleClick = () => setShowProfileModal(true);

  const Link = () => <UserFullName data={profile} onClick={openModalOnClick ? handleClick : null} {...props} />;

  return (
    <>
      {withOverlay && profile?.uuid ? (
        <Overlay
          asCardOverlay
          placement="auto"
          width="30rem"
          overlay={
            <ProfileCard
              data={{ id: profile?.slug || profile?.id }}
              onClick={handleShowProfile}
              primaryAction={
                <PrimaryButton isExpand>
                  <FormattedMessage id="Profile.ProfileModal.ButtonViewProfile" />
                </PrimaryButton>
              }
              shouldRefetch
            />
          }
          trigger={<Link />}
          delay={{ show: 1000 }}
          {...props}
        />
      ) : (
        <Link />
      )}
      <ProfileModal
        id={profile?.slug}
        show={showProfileModal}
        handleClose={() => setShowProfileModal(false)}
        handlePrimary={() => {
          window.open(links.profile(profile?.slug), "_blank");
          setShowProfileModal(false);
        }}
        {...props}
      />
    </>
  );
};

ProfileLink.propTypes = {
  profile: PropTypes.object.isRequired,
  withOverlay: PropTypes.bool,
  openModalOnClick: PropTypes.bool,
};

export default ProfileLink;
